export const MenuItems = [
  {
    title: 'Date: Crescent',
    column: 'eventDate',
    sort: 'asc'
  },
  {
    title: 'Date: Decrescent',
    column: 'eventDate',
    sort: 'desc'
  },
  {
    title: 'Place: A-Z',
    column: 'place',
    sort: 'asc'
  },
  {
    title: 'Place: Z-A',
    column: 'place',
    sort: 'desc'
  }
];
